import React from 'react';
import BaseTable from '../tables/BaseTable';
import formatters from '../../../utils/forms/formatters'


export default class AmortizationModal extends React.PureComponent {

    getTotalAmountFinanced() {
        let val;
         try {
             let schedule_data = this.props.data.estimates.find((e) => e.id == this.props.specOptionId)?.attributes.find((a) => a.id == this.props.lineId)?.schedule
             val =  schedule_data[0].balance + schedule_data[0].principal

         } catch (e) {
             val = this.props.data?.project_lead?.amount
         }

         return formatters.USDCurrency.formatter(val);
    }

    render() {
        let schedule_data = this.props.data.estimates.find((e) => e.id == this.props.specOptionId)?.attributes.find((a) => a.id == this.props.lineId)?.schedule
        if (schedule_data) {
            schedule_data = schedule_data.map((d) => ({
                ...d,
                balance: formatters.USDCurrency.formatter(d.balance),
                interest: formatters.USDCurrency.formatter(d.interest),
                principal: formatters.USDCurrency.formatter(d.principal),
                payment: formatters.USDCurrency.formatter(d.payment),
            }))
        }
        return (
            <div className={`modal ${this.props.visible ? 'is-active' : ''}`}>
                <div className="modal-background"/>
                <div className="modal-card"
                     style={this.props.cardStyle ? this.props.cardStyle : {}}
                >
                    <header className="modal-card-head">
                        <h5 className="title is-5 has-text-white-bis">{this.props.title || "Amortization"}</h5>
                    </header>
                    <div className="modal-card-body">
                        <div className="my-3">
                            <p>Total Amount Financed:
                                <span className="has-text-weight-semibold"> {this.getTotalAmountFinanced()}</span>
                            </p>
                            <p className="has-text-grey is-size-7">Initial balance may be higher than this amount due to capitalized interest and fees.</p>
                        </div>
                        <div className="table-wrapper is-flex is-justify-content-center">
                            <BaseTable
                                data={schedule_data}
                                columns={['year', 'number', 'payment', 'principal', 'interest', 'balance']}
                                sortable={false}
                                rowStyle="has-text-info"
                            />
                        </div>
                        {this.props.children}
                    </div>
                    {this.props.onClose &&
                        <button className="modal-close is-large" style={{float: 'right'}} aria-label="close" onClick={this.props.onClose}/>
                    }
                </div>

            </div>
        )
    }

}